import { detectMediaType } from './media-type-detector';

/**
 * Does the edge produce a preview thumbnail for this file at all?
 *
 * 2026-09-02: `THUMBNAIL_LOAD_FAILED` was firing ~2,850 times a day in prod and every one of
 * them was noise: 100 % had `attempts=2`, and the top pages were `/audio-compressor`,
 * `/convert-flac-to-mp3`, `/compress-mp3`, `/convert-mp3-to-wav`. The edge's
 * `DownloadsService.getThumbnail` answers 404 when `getPreviewThumbnailPath` has nothing for
 * the file, which is always the case for audio. The card then retried after 1.2 s, showed the
 * "Preview couldn't load" state with a Retry button, and reported a failure that never was one.
 * Gating on the extension (the only thing the browser knows before the request) turns the
 * metric back into a signal and removes the pointless retry.
 *
 * Unknown/empty extensions stay "expected" so a genuine failure on an odd file is still counted.
 */
export function serverThumbnailExpected(fileName: string | null | undefined): boolean {
    if (!fileName) return true;
    const dot = fileName.lastIndexOf('.');
    if (dot <= 0 || dot === fileName.length - 1) return true;
    const ext = fileName.slice(dot + 1).toLowerCase();
    return detectMediaType(ext) !== 'audio';
}
